import { useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../Redux/hooks";
import ScreeningParticipantLayout from "./ScreeningParticipantLayout";
import { logoutParticipantToStudyLanding } from "./screeningParticipantLogout";

const REDIRECT_SECONDS = 5;

const ScreeningNotConfigured = () => {
  const { t } = useTranslation("participant-flow");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);
  const [redirecting, setRedirecting] = useState(false);
  const redirectedRef = useRef(false);

  const redirectToLanding = async () => {
    if (redirectedRef.current) {
      return;
    }
    redirectedRef.current = true;
    setRedirecting(true);
    await logoutParticipantToStudyLanding(dispatch, navigate);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          redirectToLanding();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <ScreeningParticipantLayout>
      <InfoOutlinedIcon sx={{ fontSize: 64, color: "primary.main", mb: 2 }} />
      <Typography
        variant="h5"
        fontWeight="medium"
        color="text.primary"
        textAlign="center"
      >
        {t("SCREENING_NOT_CONFIGURED_TITLE")}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        sx={{ mt: 1, maxWidth: 440 }}
      >
        {t("SCREENING_NOT_CONFIGURED_BODY")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {redirecting
          ? t("SCREENING_NOT_CONFIGURED_REDIRECTING")
          : t("SCREENING_NOT_CONFIGURED_COUNTDOWN", { seconds: secondsLeft })}
      </Typography>
      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          onClick={redirectToLanding}
          disabled={redirecting}
        >
          {redirecting ? (
            <CircularProgress size={22} sx={{ color: "common.white" }} />
          ) : (
            t("SCREENING_NOT_CONFIGURED_GO_NOW")
          )}
        </Button>
      </Box>
    </ScreeningParticipantLayout>
  );
};

export default ScreeningNotConfigured;
